"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";

/**
 * Whether the element matching `selector` is currently intersecting the
 * viewport. Unlike `useNearViewport` this reports both ways, for UI that has to
 * step aside while something else is on screen.
 *
 * Takes a selector rather than a ref so it can watch an element outside the
 * calling component's tree, and stays `false` while nothing matches.
 */
export function useIsInView(selector) {
  const $ = _c(3);
  const [isInView, setIsInView] = useState(false);
  let t0;
  let t1;
  if ($[0] !== selector) {
    t0 = () => {
      const element = document.querySelector(selector);
      if (!element) {
        return;
      }
      const observer = new IntersectionObserver(t2 => {
        const [entry] = t2;
        return setIsInView(entry.isIntersecting);
      });
      observer.observe(element);
      return () => observer.disconnect();
    };
    t1 = [selector];
    $[0] = selector;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return isInView;
}